import React from "react";
import { createRoot } from "react-dom/client";
import CostConfirmModal from "@/components/CostConfirmModal";

// Styled cost confirmation. Resolves true when the user confirms.
// Pass `op` + `units` to pre-fill from real tracked usage (falls back to the static numbers).
export function confirmCost(opts) {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    document.body.appendChild(host);
    const root = createRoot(host);
    const done = (ok) => {
      root.unmount();
      host.remove();
      resolve(ok);
    };
    root.render(React.createElement(CostConfirmModal, { ...opts, onResolve: done }));
  });
}
